/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconMenuOrder = createReactComponent("outline", "menu-order", "IconMenuOrder", [["path", { "d": "M4 10h16", "key": "svg-0" }], ["path", { "d": "M4 14h16", "key": "svg-1" }], ["path", { "d": "M9 18l3 3l3 -3", "key": "svg-2" }], ["path", { "d": "M9 6l3 -3l3 3", "key": "svg-3" }]]);

export { IconMenuOrder as default };
//# sourceMappingURL=IconMenuOrder.mjs.map
